import React from 'react';
import { Edit, Trash2, Eye, EyeOff, Image as ImageIcon } from 'lucide-react';

const BlogPostList = ({ posts, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="p-4 border-b border-gray-100">
        <h2 className="font-semibold text-gray-800">All Blog Posts ({posts.length})</h2>
      </div>
      <div className="divide-y divide-gray-100">
        {posts.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            No blog posts yet. Create your first post!
          </div>
        ) : (
          posts.map((post) => (
            <div key={post.id} className="p-4 flex items-center gap-4 hover:bg-gray-50 transition-colors">
              {post.image ? (
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                />
              ) : (
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <ImageIcon className="w-6 h-6 text-gray-400" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-gray-800 truncate">{post.title}</h3>
                <p className="text-sm text-gray-500 truncate">{post.excerpt}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-2 py-0.5 bg-teal-100 text-teal-700 rounded">
                    {post.category}
                  </span>
                  {post.published ? (
                    <span className="text-xs text-green-600 flex items-center gap-1">
                      <Eye className="w-3 h-3" /> Published
                    </span>
                  ) : (
                    <span className="text-xs text-gray-400 flex items-center gap-1">
                      <EyeOff className="w-3 h-3" /> Draft
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onEdit(post)}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                  title="Edit post"
                  data-testid={`edit-post-${post.id}`}
                >
                  <Edit className="w-4 h-4 text-gray-500" />
                </button>
                <button
                  onClick={() => onDelete(post.id)}
                  className="p-2 hover:bg-red-50 rounded-lg transition-colors"
                  title="Delete post"
                  data-testid={`delete-post-${post.id}`}
                >
                  <Trash2 className="w-4 h-4 text-red-500" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlogPostList;
